'use client'
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "types";

import { Container, Box } from "@mui/material";
import ResetPassword from "./sections/ResetPassword";

function ResetPasswordPage() {
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.user.user);

  useEffect(() => {
    if (user) navigate("/home", { replace: true });
  }, [user, navigate]);

  const setSignin = () => navigate("/signin");
  const setSignup = () => navigate("/signup");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        my: 8,
      }}
    >
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <ResetPassword setSignin={setSignin} setSignup={setSignup} />
        </Box>
      </Container>
    </Box>
  );
}

export default ResetPasswordPage;